import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)
Vue.use(Vuex)

var newDamage = {
	images: [],
	description: null,
	active: null
}

var id_workshop_user = (window.mpsWorkshopUserId && window.mpsWorkshopUserId.length == 1) ? window.mpsWorkshopUserId[0] : null;
var id_workshop = window.mpsWorkshopId ? window.mpsWorkshopId : null;
id_workshop = id_workshop ? id_workshop : id_workshop_user;

var newRequest = {
	id: null,
	contact_name: null,
	address: null,
	contact_email: null,
	contact_phone: null,
	contact_company: null,
	car_id: null,
	mileage: null,
	damage_date: null,
	insurance_company: null,
	consent: 1,
	consent_second: 1,
	description_1: null,
	description_2: null,
	description_3: null,
	description_4: null,
	description_5: null,
	description_6: null,
	damage_7_label: 'Tak',
	description_7: null,
	description_8: null,
	damage_8_label: 'Dokumentasjon',
	damage_8_state: '',
	description_9: null,
	description_10: null,
	description_11: null,
	description_12: null,
	description_13: null,
	description_14: null,
	description_15: null,
	description_16: null,
	damaged_at: null
}

var newContact = {
	id: null,
	name: '',
	address: '',
	email: '',
	phone: '',
	company: ''
}

const store = new Vuex.Store({
	state: {
		car: {},
		companies: [
			'Andre forsikringsselskap',
			'ALFA FORSIKRING',
			'COVERME',
			'CRAWFORD & COMPANY FORSIKRING',
			'Eika Forsikring',
			'Enter forsikring',
			'Euro Insurance LTD',
			'Fremtind (DNB)',
			'Fremtind (SB1)',
			'Frende Skadeforsikring',
			'Gjensidige',
			'If Skadeforsikring',
			'Inter Hannover',
			'JBF',
			'KLP Skadeforsikring',
			'KNIF Trygghet Forsikring',
			'Landkreditt Forsikring',
			'LY FORSIKRING',
			'Møretrygd Gjensidig Forsikring',
			'NORDEUROPA FORSIKRING',
			'Oslo Forsikring',
			'Protector Forsikring',
			'SEDGWICK NORGE FORSIKRING',
			'Storebrand Forsikring',
			'Tide Forsikring',
			'TRIBE VENNEFORSIKRING',
			'Tryg Forsikring',
			'VAN AMEYDE NORWAY',
			'Volvia Forsikring',
			'W R Berkley',
			'WATERCIRCLES NORGE',
			'WINTERBERGH FORSIKRING',
			'YETZ FORSIKRING',
			'Zurich Insurance'
		],
		damages: [
			JSON.parse(JSON.stringify(newDamage)),
			JSON.parse(JSON.stringify(newDamage)),
			JSON.parse(JSON.stringify(newDamage)),
			JSON.parse(JSON.stringify(newDamage)),
			JSON.parse(JSON.stringify(newDamage)),
			JSON.parse(JSON.stringify(newDamage)),
			JSON.parse(JSON.stringify(newDamage)),
			JSON.parse(JSON.stringify(newDamage)),
		],
		contact: JSON.parse(JSON.stringify(newContact)),
		request: JSON.parse(JSON.stringify(newRequest)),
	},
	getters: {
		car(state) {
			return state.car
		},
		contact(state) {
			return state.contact
		},
		damages(state) {
			return state.damages
		},
		request(state) {
			return state.request
		},
		companies(state){
			return state.companies
		},
	},
	mutations: {
		set(state, {type, val}) {
			state[type] = val
		},
		setItem(state, {type, item, val}) {
			if (typeof state[type] == 'object')
				state[type][item] = val
		},
		new(state) {
			state['car'] = {};
			state['damages'] = [
				JSON.parse(JSON.stringify(newDamage))
			];
			state['contact'] = JSON.parse(JSON.stringify(newContact));
			state['request'] = JSON.parse(JSON.stringify(newRequest));
		}
	},
	actions: {}
})

export {store, newDamage}


// WEBPACK FOOTER //
// ./requests/assets/src/store/index.js